import { Link } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import { DescriptionRounded, ReplayOutlined, WarningAmberRounded } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useRceDepositMutation } from "../../api/updateRceDeposit";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { useContext, useState } from "react";
import { setSnackbar } from "../../../../../../util/state/globalAction";
import { snackbarTypes } from "../../../../../../util/state/globalVariables";
import { GlobalContext } from "../../../../../../util/state/GlobalContextProvider";

function CellActions(params: any) {
    const { t } = useTranslation('booking');
    const [showConfirmDeposit, setShowConfirmDeposit] = useState(false);

    const rceDepositMutation = useRceDepositMutation();
    const { dispatchGlobalData } = useContext(GlobalContext);

    function confirmButtonClick() {
        rceDepositMutation.mutate({
            bookingId: params.data?.id,
            depositType: params.data?.depositType,
            depositAmount: params.data?.depositAmount,
            preautAmount: params.data?.preautAmount
        },
            {
                onSuccess: () => {
                    dispatchGlobalData({
                        type: setSnackbar,
                        payload: {
                            snackbar: {
                                message: t('message.success.default'),
                                type: snackbarTypes.success,
                                show: true,
                                autoClose: true,
                            }
                        }
                    });
                    setShowConfirmDeposit(false);

                    params.api.refreshServerSideStore({ purge: true });
                },
                onError: () => {
                    dispatchGlobalData({
                        type: setSnackbar,
                        payload: {
                            snackbar: {
                                message: t('message.error.default'),
                                type: snackbarTypes.error,
                                show: true,
                                autoClose: true,
                            }
                        }
                    });
                }
            })
    }

    return (
        <>
            <Link to={`/booking/view/${params.data?.id}`} target="_blank">
                <IconButton title={t('label.details')} color="accent">
                    <DescriptionRounded />
                </IconButton>
            </Link>
            <IconButton
                color="accent"
                size="small"
                onClick={() => {
                    setShowConfirmDeposit(true)
                }}
                disabled={!(params.data?.raStatus === "READY_TO_PAY")}
            >
                <ReplayOutlined />
            </IconButton>
            <Dialog
                open={showConfirmDeposit}
                onClose={() => { }}
                aria-labelledby="responsive-dialog-title"
                disableEscapeKeyDown={true}
            >
                <DialogContent>
                    <DialogContentText>
                        {t('message.confirm_change_deposit_type')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="outlined"
                        onClick={() => setShowConfirmDeposit(false)}
                    >
                        {t('action.CANCEL')}
                    </Button>
                    <Button
                        onClick={() => confirmButtonClick()}
                    >
                        {t('action.CONFIRM')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default CellActions;